import { Component, OnInit, Input, ApplicationRef, OnChanges } from '@angular/core';
import { GmapsService } from 'projects/core/src/lib/core/data/gmaps/gmaps.service';

@Component({
    selector: 'app-gmaps',
    templateUrl: './gmaps.component.html',
    styleUrls: ['./gmaps.component.scss']
})
export class GmapsComponent implements OnInit, OnChanges {

    @Input()
    location: string;

    @Input()
    lat = 51.678418;

    @Input()
    lng = 7.809007;

    shopLat = 48.171493;
    shopLong = -122.150946;

    @Input()
    zoom = 11;

    constructor(
        private gmapsService: GmapsService,
        private appRef: ApplicationRef
    ) { }

    ngOnInit() {
        // this.updateLocation(this.location)
    }

    ngOnChanges() {
        this.updateLocation(this.location)
    }

    protected updateLocation(location: string) {
        this.gmapsService
            .getGeolocation(location)
            .subscribe(results => {
                if (results && results.length > 0) {
                    this.lat = results[0].geometry.location.lat();
                    this.lng = results[0].geometry.location.lng();
                    this.appRef.tick();
                }
            })
    }

}
